export default {
    setSelectedVehicle(context, payload) {
        context.commit('selectedvehicle', payload);
    },
    setSelectedYear(context, payload) {
        context.commit('selectedyear', payload);
    },
    setSelectedMake(context, payload) {
        context.commit('selectedmake', payload);
    },
    setSelectedModel(context, payload) {
        context.commit('selectedmodel', payload);
    },
    setSelectedEngine(context, payload) {
        context.commit('selectedengine', payload);
    },
    setSelectedCategories(context, payload) {
        context.commit('selectedcategories', payload);
    },
    setSelectedGroups(context, payload) {
        context.commit('selectedgroups', payload);
    },
    setSelectedQuestions(context, payload) {
        context.commit('selectedquestions', payload);
    },
    addToSavedVehicleList(context) {
        let id = 0;
        let vehiclelist = context.state.savedvehiclelist;

        // Set an incrementing id for each selected vehicle
        if (context.state.savedvehiclelist.length > 0) {
            id = Math.max(...context.state.savedvehiclelist.map(vehicle => vehicle.id));
        }
        id++;

        vehiclelist.push({
            "id": id,
            "year": context.state.selectedyear,
            "make": context.state.selectedmake,
            "model": context.state.selectedmodel,
            "engine": context.state.selectedengine,
        });

        context.commit('savedvehiclelist', vehiclelist);
    },
    setNewSavedVehicleAdded(context, payload) {
        context.commit('newsavedvehicleadded', payload);
    },
    clearSelectedVehicle(context) {
        context.commit('clearSelectedVehicle');
    },
    setKit_vehicle(context, payload) {
        context.commit('setKit_vehicle', payload);
    },

    setIndustry_sels(context, payload){
        context.commit('setIndustry_sels', payload);
    },

}